import React from "react";
import { Stage, Layer, Rect, Text, Circle, Line } from 'react-konva';
import {connect} from 'react-redux';

import {apiRequest} from '../actions/fixture';





class Fixture extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onApiRequest();
    }




  render() {
    if(typeof this.props.fixture.isLoaded === 'undefined' ) {
        return (  <div >
              Loading...
            </div>

        )
    }
    if(typeof this.props.fixture.tfData === 'undefined' || typeof this.props.fixture.tfData.tournament_fixtures ==='undefined') {
        return (  <div >
                      No Result Found
                    </div>

                )
    }
    let tMatches = getLength(this.props.fixture.tfData.tournament_fixtures);
    if(tMatches===0) {
        return (  <div >
                      No Result Found
                    </div>

                )
    }

    let tf = []
    for ( var i = 0; i < tMatches; i++) {
      tf.push(<FixtureShow key={i} fixtureData={this.props.fixture.tfData.tournament_fixtures[i]}  />);
    }
  return (
             <React.Fragment>
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Tournament Fixture</h1>
                </div>
                <div id="mainDiv" >
                    {tf}
                </div>
            </React.Fragment>
        )
  }
}

class FixtureShow extends React.Component {
    constructor(props) {
        super(props);
    }

  render() {

    let tRound = getLength(this.props.fixtureData.tournament_matches)
    let tRoundMatch = []
    for (var i = 1; i <= tRound; i++) {
      tRoundMatch[i] = getLength(this.props.fixtureData.tournament_matches[i])
    }

    let fixture = []
    for ( i = 1; i <= tRound; i++) {

      fixture.push(<GetRectParent key={i}  tRound={tRound} tRoundMatch={tRoundMatch} fixtureData={this.props.fixtureData.tournament_matches[i]} i={i}  />);
    }
    let newWidth = tRound*340;
    let divStyle = {
      //width: newWidth+'px',
      paddingBottom : '50px'
    };
    let h2style = {
          width: '100%'
        };
    let dStyle = {
        background: 'white',
        width: '100%',
        overflow: 'auto',
        whiteSpace: 'nowrap'
    };


  return (  <div className="row" style={divStyle}>
                <h2 style={h2style}>{this.props.fixtureData.name.toUpperCase()}</h2>
                <div style={dStyle}>
                    {fixture}
                </div>
            </div>

        )
  }
}

function getLength(data) {
	//console.log('something');
  if(typeof data !== 'object') {
    return data.length;
  } else {
    var size = 0, key;
    for (key in data) {
        if (data.hasOwnProperty(key)) size++;
    }
    return size;
  }
}


class GetRectParent extends React.Component {
  render() {
    let fixtureChild = [];
    for (var j = 1; j <= this.props.tRoundMatch[this.props.i]; j++) {
      fixtureChild.push(        <GetRect
                                    key={this.props.i+j}
                                    tRound={this.props.tRound}
                                    tRoundMatch={this.props.tRoundMatch}
                                    i={this.props.i}
                                    j={j}
                                    fixtureChildData={this.props.fixtureData[j-1]}
                                  />
      )
    }
    return (<div className={'round'}>

        {fixtureChild}
        </div>
    )
  }


}
class GetRect extends React.Component {
	//console.log('smtng');
  getPadHeight (count)  {
  	if(count === 1) {
  		return 60;
  	}
  	return (this.getPadHeight(count-1)*2)+30;
  }

  render() {
    let padHeight = this.getPadHeight(this.props.i);
    let isBye = '';
    if(typeof this.props.fixtureChildData.isBye !== 'undefined') {
       // isBye = 'hidden';
    }

    return (
      <Stage className={'rect ' + isBye }  width={315} height={padHeight}>
        <GetRectPlayer key={this.props.i+'ack'+this.props.j} padHeight={padHeight} fixtureChildData={this.props.fixtureChildData} j={this.props.j} i={this.props.i} tRound={this.props.tRound} />
      </Stage>
    );
  }
}

class GetRectPlayer extends React.Component {
	//console.log('smtng');

  getCurrentMatchScore(score,palyerType) {
  let matchScore = []
    if(palyerType===1) {
        if(typeof score[0] !== 'undefined') {
            matchScore.push(score[0].player1_score)
        } else {
            matchScore.push('-')
        }

        if(typeof score[1] !== 'undefined') {
            matchScore.push(score[1].player1_score)
        } else {
            matchScore.push('-')
        }

        if(typeof score[2] !== 'undefined') {
            matchScore.push(score[2].player1_score)
        } else {
            matchScore.push('-')
        }
    } else {
        if(typeof score[0] !== 'undefined') {
            matchScore.push(score[0].player2_score)
        } else {
            matchScore.push('-')
        }

        if(typeof score[1] !== 'undefined') {
            matchScore.push(score[1].player2_score)
        } else {
            matchScore.push('-')
        }

        if(typeof score[2] !== 'undefined') {
            matchScore.push(score[2].player2_score)
        } else {
            matchScore.push('-')
        }
    }
    return matchScore;
  }

  render() {
    let fcData = this.props.fixtureChildData;
    let playerData = [];
    let key=0;
    let iswinner = 0;
    let cMatchScore = ['-','-','-']
    let matchScore = ['-','-','-']
    if(typeof fcData.player1 !== 'undefined') {
      if(typeof fcData.winner !== 'undefined' && fcData.winner.id === fcData.player1.id) { iswinner = 1; }
      matchScore = cMatchScore;
      if(typeof fcData.tournament_match_scores !== 'undefined' && typeof fcData.tournament_match_scores[0] !== 'undefined' && typeof fcData.tournament_match_scores[0].round !== 'undefined') {
        matchScore = this.getCurrentMatchScore(fcData.tournament_match_scores,1);
      }
      playerData.push(<PlayerData key={this.props.i+'ak'+this.props.j+''+key++} matchScore={matchScore} iswinner={iswinner} upperrect={1} player={fcData.player1} show={fcData.player1_description} type={1} padHeight={this.props.padHeight}/>);

    }
    if(typeof fcData.player2 !== 'undefined') {
      iswinner = 0;if(typeof fcData.winner !== 'undefined' && fcData.winner.id === fcData.player2.id) { iswinner = 1; }
      matchScore = cMatchScore;
      if(typeof fcData.tournament_match_scores !== 'undefined' && typeof fcData.tournament_match_scores[0] !== 'undefined' && typeof fcData.tournament_match_scores[0].round !== 'undefined') {
        matchScore = this.getCurrentMatchScore(fcData.tournament_match_scores,2);
      }
      playerData.push(<PlayerData key={this.props.i+'ak'+this.props.j+''+key++} matchScore={matchScore} iswinner={iswinner} upperrect={0} player={fcData.player2} show={fcData.player2_description} type={2} padHeight={this.props.padHeight}/>);
    }
    if(typeof fcData.player1_match !== 'undefined') {
      let pDesc = 'To be played';iswinner = 0;
      matchScore = cMatchScore;
      if (typeof fcData.player1_match.winner !== 'undefined' ) {
        if(fcData.player1_match.winner.id === fcData.player1_match.player1.id)
          pDesc = fcData.player1_match.player1_description
        if(fcData.player1_match.winner.id === fcData.player1_match.player2.id)
          pDesc = fcData.player1_match.player2_description

        if(typeof fcData.tournament_match_scores !== 'undefined' && typeof fcData.tournament_match_scores[0] !== 'undefined' && typeof fcData.tournament_match_scores[0].round !== 'undefined') {
          matchScore = this.getCurrentMatchScore(fcData.tournament_match_scores,1);
        }
      }
      playerData.push(<PlayerData iswinner={iswinner} key={this.props.i+'ak'+this.props.j+''+key++} matchScore={matchScore} upperrect={1} player={fcData.player1_match} show={pDesc} type={1} padHeight={this.props.padHeight}/>);
    }
    if(typeof fcData.player2_match !== 'undefined') {
      let pDesc = 'To be played';iswinner = 0;
      matchScore = cMatchScore;
      if (typeof fcData.player2_match.winner !== 'undefined' ) {
        if(fcData.player2_match.winner.id === fcData.player2_match.player1.id)
          pDesc = fcData.player2_match.player1_description
        if(fcData.player2_match.winner.id === fcData.player2_match.player2.id)
          pDesc = fcData.player2_match.player2_description

        if(typeof fcData.tournament_match_scores !== 'undefined' && typeof fcData.tournament_match_scores[0] !== 'undefined' && typeof fcData.tournament_match_scores[0].round !== 'undefined') {
          matchScore = this.getCurrentMatchScore(fcData.tournament_match_scores,2);
        }
      }
      playerData.push(<PlayerData iswinner={iswinner} key={this.props.i+'ak'+this.props.j+''+key++} matchScore={matchScore} upperrect={0} player={fcData.player2_match} show={pDesc} type={2} padHeight={this.props.padHeight}/>);
    }
    let points = [240, 30, 278, 30,278,((this.props.padHeight/2)+28),315,((this.props.padHeight/2)+28)]
    if(this.props.j % 2 === 0) {
      points = [240, 30, 278, 30,278,(-1*((this.props.padHeight/2)-32)),315,(-1*((this.props.padHeight/2)-32))]
    }
    let strokeWidth = 2;
    if(this.props.tRound === this.props.i) {
      strokeWidth = 0;
    }
    let points1 = [150,60,150,0]
    let points2 = [180,60,180,0]
    let points3 = [210,60,210,0]
    return (
              <Layer >
                {playerData}
                <Line
                  x={0}
                  y={(this.props.padHeight/2)-30 }
                  points={points}
                  stroke={"#b6b4be"}
                  strokeWidth={strokeWidth}
                  ref="line"
                />
                <Line
                  x={0}
                  y={(this.props.padHeight/2)-30 }
                  points={points1}
                  stroke={"#b6b4be"}
                  strokeWidth={1}
                  ref="line"
                />
                <Line
                  x={0}
                  y={(this.props.padHeight/2)-30 }
                  points={points2}
                  stroke={"#b6b4be"}
                  strokeWidth={1}
                  ref="line"
                />
                <Line
                  x={0}
                  y={(this.props.padHeight/2)-30 }
                  points={points3}
                  stroke={"#b6b4be"}
                  strokeWidth={1}
                  ref="line"
                />
              </Layer >
    );
  }
}

class PlayerData extends React.Component {
  createNewName(newName) {
    let exNewName = newName.split(",");
    if(typeof exNewName[1] !== 'undefined' ) {
        let fname = (exNewName[0].length > 9) ? this.getCharName(exNewName[0],9) : exNewName[0];
        let sname = (exNewName[1].length > 9) ? this.getCharName(exNewName[1],9) : exNewName[1];
        return fname + ', '+ sname;
    } else {
        return this.getCharName(newName,20);
    }
  }

  getCharName(name,charLen) {
    let exName = name.split(" ");
    let tlength = name.length;
    let aik = exName.length;

    if(typeof exName[aik-1] !=='undefined' && (tlength - exName[aik-1].length) < charLen ) {
        return this.fullName(exName,aik-1);
    } else if(typeof exName[aik-2] !=='undefined' && (tlength - (exName[aik-1].length + exName[aik-2].length)  ) < charLen ) {
       return this.fullName(exName,aik-2);
    } else if(typeof exName[aik-3] !=='undefined' && (tlength - (exName[aik-1].length + exName[aik-2].length + exName[aik-3].length)  ) < charLen ) {
        return this.fullName(exName,aik-3);
    } else {
        return this.fullName(exName,0);
    }

  }

  fullName(nameArr,lastL) {
    let newName = '';
    for(let ij=0;ij< nameArr.length; ij++) {
        if(ij < lastL) {
            newName += nameArr[ij]+' ';
        } else {
            newName += nameArr[ij].charAt(0) +' ';
        }
    }
    return newName.trim();
  }


  render() {
    let showName = this.props.show;

    if(typeof this.props.show !== 'undefined' && this.props.show.length > 20) {
        showName = this.createNewName(this.props.show)
    }
    let addFector = 0;let colorCode = '#f1f1f1';let circleColor = '#dcdcdc';
    if(this.props.type > 1) {
      addFector = 30* (this.props.type-1);
    }
    if(this.props.iswinner === 1) {
        colorCode =  '#ffffff';
        circleColor = '#8470e0';
    }
    let radiusS = [0,0,10,10];
    if(this.props.upperrect === 1) {
        radiusS = [10,10,0,0];
    }
    return (
              <React.Fragment>
              <Rect
                width={240}
                height={30}
                fill={colorCode}

                stroke= {'#b6b4be'}
                strokeWidth= {1}
                cornerRadius={radiusS}
                x={0}
                y={0+addFector+((this.props.padHeight/2)-30)}
              />

              <Text x={10} y={15+addFector+((this.props.padHeight/2)-33)} text={showName} fontSize={14} />
              <Text x={155} y={15+addFector+((this.props.padHeight/2)-33)} text={this.props.matchScore[0].toString()} fontSize={10} />
              <Text x={185} y={15+addFector+((this.props.padHeight/2)-33)} text={this.props.matchScore[1].toString()} fontSize={10} />
              <Text x={215} y={15+addFector+((this.props.padHeight/2)-33)} text={this.props.matchScore[2].toString()} fontSize={10} />
              </React.Fragment>
    );
  }
}



//export default Fixture;


const mapStateToProps = (state,props) => {
  return {
    fixture: state.fixture
  }
}
const mapActionsToProps =  {
      onApiRequest : apiRequest,
}
export default connect(mapStateToProps,mapActionsToProps) (Fixture);

